<div class="control-section">
	<div>
		<div id="default_title_bar" class="e-de-ctn-title row">
			<div class="action-left col-3"></div>
			<div class="center col-6">
				{{ this.data.name }}
			</div>
			<div class="col-3">
				<span class="pull-right close-icon" (click)="close()">
					<mat-icon>clear</mat-icon>
				</span>
			</div>
		</div>
		<div>
			<pdf-viewer [src]="this.fileURL" [render-text]="true" style="display: block" [stick-to-page]="true"></pdf-viewer>
		</div>
	</div>
</div>
